const pageNameKey = "validateUserDrawerInputsUtil";

export const validateUserDrawerInputsUtilEn = {
  [pageNameKey]: {
    username: "Username",
    given_name: "Given name",
    family_name: "Family name",
    email: "Email",
    name: "Name",
    description: "Description",
    expiration_date: "Expiration date",
  },
};

export const validateUserDrawerInputsUtilPtBr = {
  [pageNameKey]: {
    username: "Nome de usuário",
    given_name: "Nome",
    family_name: "Sobrenome",
    email: "E-mail",
    name: "Nome",
    description: "Descrição",
    expiration_date: "Data de validade",
  },
};

export const validateUserDrawerInputsUtilDe = {
  [pageNameKey]: {
    username: "Benutzername",
    given_name: "Vorname",
    family_name: "Nachname",
    email: "E-Mail",
    name: "Name",
    description: "Beschreibung",
    expiration_date: "Ablaufdatum",
  },
};

export const validateUserDrawerInputsUtilZhHans = {
  [pageNameKey]: {
    username: "用户名",
    given_name: "名字",
    family_name: "姓氏",
    email: "电子邮件",
    name: "名称",
    description: "描述",
    expiration_date: "到期日",
  },
};

export const validateUserDrawerInputsUtilIt = {
  [pageNameKey]: {
    username: "Nome utente",
    given_name: "Nome",
    family_name: "Cognome",
    email: "Email",
    name: "Nome",
    description: "Descrizione",
    expiration_date: "Data di scadenza",
  },
};

export const validateUserDrawerInputsUtilEs = {
  [pageNameKey]: {
    username: "Nombre de usuario",
    given_name: "Nombre",
    family_name: "Apellido",
    email: "Correo electrónico",
    name: "Nombre",
    description: "Descripción",
    expiration_date: "Fecha de vencimiento",
  },
};

export const validateUserDrawerInputsUtilNl = {
  [pageNameKey]: {
    description: "Beschrijving",
    email: "E-mail",
    expiration_date: "Vervaldatum",
    family_name: "Achternaam",
    given_name: "Voornaam",
    name: "Naam",
    username: "Gebruikersnaam",
  },
};

export const validateUserDrawerInputsUtilTr = {
  [pageNameKey]: {
    description: "Tanım",
    email: "E-posta",
    expiration_date: "Son kullanma tarihi",
    family_name: "Aile adı",
    given_name: "İsim",
    name: "İsim",
    username: "Kullanıcı adı",
  },
};
